export default "__VITE_ASSET___arQKgZ___"